import React from 'react';
import { Item, AppTranslationHelper } from 'common/types';
import { Card } from '../';
import styles from './variantModal.module.css';

type VariantModalProps = {
  isOpen: boolean;
  onClose: () => void;
  parentItem: Item | null;
  variants: Item[];
  translation: AppTranslationHelper;
  onSelectVariant: (item: Item) => void;
};

const VariantModal: React.FC<VariantModalProps> = ({
  isOpen,
  onClose,
  parentItem,
  variants,
  translation,
  onSelectVariant
}) => {
  if (!isOpen || !parentItem) return null;

  const { t } = translation;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3>{parentItem.name} - {t('terminal.variantSelection')}</h3>
          <button className={styles.closeButton} onClick={onClose}>×</button>
        </div>
        <div className={styles.modalBody}>
          {variants.length === 0 ? (
            <div className={styles.noVariants}>{t('terminal.noVariantsAvailable')}</div>
          ) : (
            <div className={styles.variantGrid}>
              {variants.map((variant) => (
                <Card
                  key={variant.id}
                  color={variant.color}
                  translation={translation}
                  label={variant.name}
                  onClick={() => {
                    onSelectVariant(variant);
                    onClose();
                  }}
                  picture={variant.picture}
                  price={variant.price}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VariantModal;
